export default __webpack_public_path__ + "static/data-more-about-img-12d266479b0962161d07bf40fc739148.png";